import { Tabs, styled, Tab } from '@mui/material';

import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'common/store/AppStore';
import { setOverviewSelectedTab } from 'common/store/reducer/userManagementReducer';

import styles from './OverviewTabs.module.scss';

const { backgroundWhite, tabText, selectedTabText, selectedTabbackground } =
	styles;

interface StyledTabsProps {
	children?: React.ReactNode;
	value: number;
	onChange: (event: React.SyntheticEvent, newValue: number) => void;
}
const StyledTabs = styled((props: StyledTabsProps) => (
	<Tabs
		variant="fullWidth"
		{...props}
		TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
	/>
))({
	paddingTop: '6px',
	backgroundColor: backgroundWhite,
	minHeight: '43px',
	paddingLeft: '6px',
	marginTop: '19px',
	'& .MuiTabs-indicator': {
		display: 'flex',
		justifyContent: 'center',
		backgroundColor: 'transparent',
	},
});

interface StyledTabProps {
	label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
	<Tab disableRipple {...props} />
))(({ theme }) => ({
	textTransform: 'none',
	fontWeight: theme.typography.fontWeightRegular,
	marginRight: theme.spacing(1),
	minHeight: '1.5rem',
	fontSize: '16px',
	color: tabText,
	padding: '0px 10px',
	'&.Mui-selected': {
		color: selectedTabText,
		height: '32px',
		alignItems: 'center',
		gap: '8px',
		backgroundColor: selectedTabbackground,
		borderRadius: '2px',
		minHeight: '1.5rem',
	},
	'&.Mui-focusVisible': {
		backgroundColor: selectedTabbackground,
	},
}));
const OverViewTabs = () => {
	const dispatch = useDispatch();
	const selectedTab = useSelector(
		(state: RootState) => state.usersmanagement.selectedOverviewTab,
	);
	const [value, setValue] = React.useState(selectedTab);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
		dispatch(setOverviewSelectedTab(newValue));
	};

	return (
		<div
			className={styles['overview-tabs']}
			data-testid="overview-tab-container"
		>
			<div className={styles['overview-tabs-block']}>
				<StyledTabs
					value={value}
					data-testid="overview-alltabs-container"
					onChange={handleChange}
					aria-label="scrollable prevent tabs example"
				>
					<StyledTab label="All Activities(25)" />
					<StyledTab label="Success(20)" />
					<StyledTab label="Failed(5)" />
				</StyledTabs>
			</div>
		</div>
	);
};
export default OverViewTabs;
